import React from 'react';
import PropTypes from "prop-types";
import { Form } from "reactstrap";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Loader from "../../../common/Loader";
import FormFooter from "../../../common/forms/FormFooter";
import BusBodyworkFormFields from './BusBodyworkFormField';

export const BusBodyworkForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <BusBodyworkFormFields
        initialValues={initialValues}
      />
      <FormFooter />
    </Form>
  );
};

BusBodyworkForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({}),
};

BusBodyworkForm.defaultProps = {
  initialValues: null,
};

const mapStateToProps = (state) => ({
  loading: !state.BusUnit.BusBodyWork.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'BusBodyworkForm',
})(BusBodyworkForm);

export default connect(mapStateToProps)(formComponent);